module.exports = __webpack_public_path__ + "img/inhouseSeminar1.7e11f0cd.jpg";